module.exports = __webpack_public_path__ + "img/serch_icon.d542d8b3.png";